module.exports = __webpack_public_path__ + "76e90e01fddddbec88079e6fc995ee6b.png";